
export default function(){
    //gets offset and adds 1rem to account for margin
    var fromLeft = $('.site-switcher').offset().left;

    //sets initial position of site switcher menu
    $('.site-switcher-logos').css('left', -fromLeft - 16);

    //updates on hover
    $('.site-switcher').on('hover', function(){
        fromLeft = $('.site-switcher').offset().left;
        $('.site-switcher-logos').css('left', -fromLeft);
    });

    //updates on resize
    $(window).resize(function(){
        fromLeft = $('.site-switcher').offset().left;
        $('.site-switcher-logos').css('left', -fromLeft);
    });
}
